import { render, staticRenderFns } from "./CopyTab.vue?vue&type=template&id=dffc5e4c"
import script from "./CopyTab.vue?vue&type=script&lang=js"
export * from "./CopyTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports